if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.points = new Map();
      this.images = new Map();
      this.direction = 1;
      this.onBack = () => {
        if (this.hasAttribute('open') && history.state?.productImageModal !== this.historyKey) {
          this.closeImageModal();
        }
      };
      window.addEventListener('popstate', this.onBack);
      this.addEventListener('pointerdown', (event) => this.startGesture(event), true);
      this.addEventListener('pointermove', (event) => this.moveGesture(event), { capture: true, passive: false });
      this.addEventListener('pointerup', (event) => this.endGesture(event, false), true);
      this.addEventListener('pointercancel', (event) => this.endGesture(event, true), true);
      this.addEventListener('dragstart', (event) => {
        if (event.target.closest('img[data-media-id]')) event.preventDefault();
      });
      this.addEventListener('keydown', (event) => {
        if (!this.hasAttribute('open') || !this.currentImage) return;
        const state = this.images.get(this.currentImage);
        if (!state || !['+', '=', '-', '0'].includes(event.key)) return;
        event.preventDefault();
        const box = this.currentImage.getBoundingClientRect();
        const scale = event.key === '0' ? 1 : state.scale + (event.key === '-' ? -0.25 : 0.25);
        this.setZoom(scale, box.left + box.width / 2, box.top + box.height / 2);
      });
    }

    show(opener) {
      if (this.hasAttribute('open')) return;
      super.show(opener);
      this.container = this.querySelector('[role="document"]');
      this.showActiveMedia();
      this.points.clear();
      this.gesture = null;
      this.direction = 1;
      const image = this.querySelector('img[data-media-id].active');
      if (image) this.selectImage(image);
      this.historyKey = `product-image-${Date.now()}-${Math.random()}`;
      history.pushState({ ...history.state, productImageModal: this.historyKey }, '', location.href);
    }

    hide() {
      if (!this.hasAttribute('open')) return;
      const ownsEntry = history.state?.productImageModal === this.historyKey;
      this.closeImageModal();
      if (ownsEntry) history.back();
    }

    closeImageModal() {
      for (const [image, state] of this.images) {
        if (state.originalStyle === null) image.removeAttribute('style');
        else image.setAttribute('style', state.originalStyle);
      }
      for (const id of this.points.keys()) {
        if (this.hasPointerCapture(id)) this.releasePointerCapture(id);
      }
      this.images.clear();
      this.points.clear();
      this.currentImage = null;
      this.gesture = null;
      super.hide();
    }

    selectImage(image) {
      this.currentImage = image;
      if (!this.images.has(image)) {
        const width = image.getBoundingClientRect().width;
        if (!width) return false;
        this.images.set(image, {
          originalStyle: image.getAttribute('style'),
          width,
          scale: 1,
        });
      }
      return true;
    }

    startGesture(event) {
      if (!this.hasAttribute('open') || !this.container) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (!this.container.contains(event.target)) return;
      if (event.target.closest('button, a, input, video, iframe, deferred-media, product-model')) return;
      const image = event.target.closest('img[data-media-id]');
      if (!this.points.size) {
        if (image && !this.selectImage(image)) return;
        this.gesture = {
          tapImage: image,
          startX: event.clientX,
          startY: event.clientY,
          started: performance.now(),
          moved: false,
          multiple: false,
        };
      }
      this.points.set(event.pointerId, { x: event.clientX, y: event.clientY });
      this.setPointerCapture(event.pointerId);
      if (this.points.size > 1) this.gesture.multiple = true;
      this.rebaseGesture();
    }

    rebaseGesture() {
      const values = [...this.points.values()];
      if (!values.length || !this.gesture) return;
      if (values.length >= 2 && this.currentImage) {
        const a = values[0];
        const b = values[1];
        this.gesture.distance = Math.max(1, Math.hypot(a.x - b.x, a.y - b.y));
        this.gesture.scale = this.images.get(this.currentImage)?.scale || 1;
        this.gesture.center = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
      } else {
        this.gesture.last = { ...values[0] };
      }
    }

    moveGesture(event) {
  if (!this.points.has(event.pointerId) || !this.gesture) return;

  event.preventDefault();

  this.points.set(event.pointerId, {
    x: event.clientX,
    y: event.clientY,
  });

  if (
    Math.hypot(
      event.clientX - this.gesture.startX,
      event.clientY - this.gesture.startY
    ) > 10
  ) {
    this.gesture.moved = true;
  }

  const values = [...this.points.values()];

  /* Pincement : conserver le zoom unifié. */
  if (values.length >= 2 && this.currentImage) {
    const a = values[0];
    const b = values[1];

    const center = {
      x: (a.x + b.x) / 2,
      y: (a.y + b.y) / 2,
    };

    const distance = Math.hypot(a.x - b.x, a.y - b.y);
    const ratio = distance / this.gesture.distance;
    const sensitivity = ratio < 1 ? 2.4 : 1;

    this.setZoom(
      this.gesture.scale * Math.pow(ratio, sensitivity),
      center.x,
      center.y
    );

    this.container.scrollLeft -=
      center.x - this.gesture.center.x;

    this.container.scrollTop -=
      center.y - this.gesture.center.y;

    this.gesture.center = center;
    this.gesture.edgeDistance = 0;
    return;
  }

  if (!this.gesture.last) return;

  const dx = event.clientX - this.gesture.last.x;
  const dy = event.clientY - this.gesture.last.y;

  this.gesture.last = {
    x: event.clientX,
    y: event.clientY,
  };

  if (this.gesture.switched) return;

  const imageBox = this.currentImage?.getBoundingClientRect();
  const containerBox = this.container.getBoundingClientRect();

  const verticalGesture =
    Math.abs(event.clientY - this.gesture.startY) >
    Math.abs(event.clientX - this.gesture.startX);

  const atTop =
    imageBox && imageBox.top >= containerBox.top - 4;

  const atBottom =
    imageBox && imageBox.bottom <= containerBox.bottom + 4;

  /*
   * Toujours autoriser le déplacement.
   * Ne plus le bloquer pendant l'attente du balayage.
   */
  this.container.scrollLeft -= dx;
  this.container.scrollTop -= dy;

  const direction =
    dy < 0 && atBottom ? 1 :
    dy > 0 && atTop ? -1 :
    0;

  if (
    !this.gesture.multiple &&
    verticalGesture &&
    direction !== 0
  ) {
    if (this.gesture.edgeDirection !== direction) {
      this.gesture.edgeDistance = 0;
      this.gesture.edgeDirection = direction;
    }

    this.gesture.edgeDistance =
      (this.gesture.edgeDistance || 0) + Math.abs(dy);

    if (this.gesture.edgeDistance >= 60) {
      this.gesture.switched = this.changeImage(direction);
      this.gesture.edgeDistance = 0;
      this.gesture.moved = true;
    }
  } else {
    this.gesture.edgeDistance = 0;
    this.gesture.edgeDirection = 0;
  }
}
 endGesture(event, cancelled) {

      if (!this.points.has(event.pointerId)) return;
      // Ne pas laisser ModalDialog fermer la photo au relâchement.
      event.stopImmediatePropagation();
      const gesture = this.gesture;
      const tap = !cancelled && gesture && !gesture.multiple && !gesture.moved &&
        performance.now() - gesture.started < 500 &&
        Math.hypot(event.clientX - gesture.startX, event.clientY - gesture.startY) <= 10;
      this.points.delete(event.pointerId);
      if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
      if (this.points.size) {
        this.rebaseGesture();
        return;
      }
      this.gesture = null;
      if (tap && gesture.tapImage) {
        this.selectImage(gesture.tapImage);
        this.tapZoom(event.clientX, event.clientY);
      } else if (tap && event.pointerType === 'mouse') {
        this.hide();
      }
    }
changeImage(direction) {
  const photos = [
    ...this.container.querySelectorAll('img[data-media-id]'),
  ].filter((image) => {
    return !image.closest('deferred-media, product-model');
  });

  const index = photos.indexOf(this.currentImage);
  if (index < 0) return false;

  const nextImage = photos[index + direction];
  if (!nextImage) return false;

  for (const [image, state] of this.images) {
    if (state.originalStyle === null) {
      image.removeAttribute('style');
    } else {
      image.setAttribute('style', state.originalStyle);
    }
  }

  this.images.clear();
  this.direction = 1;

  /* Activer la destination avant de mesurer sa taille. */
  this.container.querySelectorAll('[data-media-id]').forEach(
    (media) => media.classList.remove('active')
  );

  nextImage.classList.add('active');

  if (!this.selectImage(nextImage)) return false;

  const imageBox = nextImage.getBoundingClientRect();
  const containerBox = this.container.getBoundingClientRect();

  this.container.scrollTop +=
    imageBox.top - containerBox.top - 48;

  this.container.scrollLeft = 0;

  return true;
}


    tapZoom(x, y) {
      const state = this.images.get(this.currentImage);
      if (!state) return;
      const levels = [1, 1.5, 2, 3, 4];
      if (state.scale >= 3.99) this.direction = -1;
      if (state.scale <= 1.01) this.direction = 1;
      const next = this.direction > 0
        ? levels.find((level) => level > state.scale + 0.01) ?? 4
        : [...levels].reverse().find((level) => level < state.scale - 0.01) ?? 1;
      this.setZoom(next, x, y);
    }

    setZoom(scale, x, y) {
      const image = this.currentImage;
      const state = this.images.get(image);
      if (!state || !this.container) return;
      const before = image.getBoundingClientRect();
      if (!before.width || !before.height) return;
      const relativeX = (x - before.left) / before.width;
      const relativeY = (y - before.top) / before.height;
      state.scale = Math.max(1, Math.min(4, scale));
      image.style.setProperty('width', `${state.width * state.scale}px`, 'important');
      image.style.setProperty('max-width', 'none', 'important');
      image.style.setProperty('height', 'auto', 'important');
      image.style.setProperty('max-height', 'none', 'important');
      image.style.setProperty('transform', 'none', 'important');
      image.style.setProperty('transition', 'none', 'important');
      image.style.cursor = this.direction > 0 ? 'zoom-in' : 'zoom-out';
      const after = image.getBoundingClientRect();
      this.container.scrollLeft += after.left + relativeX * after.width - x;
      this.container.scrollTop += after.top + relativeY * after.height - y;
    }

    showActiveMedia() {
      const id = this.openedBy.getAttribute('data-media-id');
      const media = [...this.querySelectorAll('[data-media-id]')];
      const activeMedia = media.find((element) => element.getAttribute('data-media-id') === id);
      if (!activeMedia) return;
      media.forEach((element) => element.classList.toggle('active', element === activeMedia));
      const template = activeMedia.querySelector('template');
      const content = template ? template.content : null;
      activeMedia.scrollIntoView();
      const container = this.querySelector('[role="document"]');
      if (container) container.scrollLeft = Math.max(0, ((activeMedia.width || 0) - container.clientWidth) / 2);
      if (activeMedia.nodeName === 'DEFERRED-MEDIA' && content?.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }
    }
  });
}
